<template>
  <div>
    <cube-popup type="my-popup" ref="myPopup">
      <cube-loading :size="60" style="color: white"></cube-loading>
    </cube-popup>
  </div>

</template>

<script>
import 'xgplayer-mp4';
export default {
  data () {
    return {};
  },
  mounted() {
    this.$refs["myPopup"].show()
  },
  methods: {
    showPopups() {
      const component = this.$refs["myPopup"]
      component.show()
    },
    hidePopups() {
      const component = this.$refs["myPopup"]
      component.hide()
    }
  }
};
</script>

<style scoped>
</style>